"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _HitProvider = require("../provider/HitProvider");
var __jsx = _react["default"].createElement;
var LinkToHitPage = function LinkToHitPage(_ref) {
  var children = _ref.children;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useHit = (0, _HitProvider.useHit)(),
    hitProduct = _useHit.hitProduct;
  if (!hitProduct) {
    return __jsx(_react["default"].Fragment, null, children);
  }
  return __jsx(Link, {
    route: "hit-product-page"
  }, __jsx(_LinkRaw["default"], {
    title: hitProduct.url
  }, children));
};
var _default = LinkToHitPage;
exports["default"] = _default;